import { useDispatch, useSelector } from "react-redux";
import IconButton from "../IconButton";
import {
  pause,
  playMedia,
  setCurrentContent,
} from "../../redux/Slice/playerSlice";
import { setPlaylistReleases } from "../../redux/Slice/playlistReleasesSlice";
import { PlayAudioButton as StyledPlayAudioButton } from "./styled";
import {
  selectCurrentContent,
  selectIsPlaying,
} from "../../redux/selectors/playerSelector";

export const PlayAudioButton = ({
  audioFileLink,
  trackOrRelease,
  playlistReleases,
}) => {
  const dispatch = useDispatch();
  const currentContent = useSelector(selectCurrentContent);
  const isPlaying = useSelector(selectIsPlaying);

  const handlePlayClick = (e) => {
    e.stopPropagation();

    if (currentContent?.id === trackOrRelease.id && isPlaying) {
      dispatch(pause());
      return;
    }

    dispatch(playMedia(audioFileLink));
    dispatch(setCurrentContent(trackOrRelease));
    dispatch(
      setPlaylistReleases(playlistReleases.filter((item) => !item.isLive)),
    );
  };

  return (
    <IconButton as={StyledPlayAudioButton} onClick={handlePlayClick}>
      <img
        src={
          trackOrRelease.id === currentContent?.id && isPlaying
            ? "/pause.svg"
            : "/play.svg"
        }
        alt={
          trackOrRelease.id === currentContent?.id && isPlaying
            ? "Пауза"
            : "Воспроизвести"
        }
      />
    </IconButton>
  );
};
